module.exports = __webpack_public_path__ + "static/media/bg.7f852a1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/prior/bg.jpg
// module id = 2544
// module chunks = 0